var vms = vms || {};
vms.connection = vms.connection || {};

vms.connection.handleConnection = function (pId, pType, pThis) {
    apex.server.process("handleConnection", {
        x01: pId,
        x02: pType
    }, {
            dataType: "text",
            success: function (pData) {
                $("#cnct-btns-" + pId).html(pData);
				refresh_ir_report();
	}})
}


var handleConnection = vms.connection.handleConnection;